import moment from "moment";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useCallback, useEffect, useState} from "react";

const WeekCalendarContainerItem = (props) => {
  const queryParams = useLocation();
  const {data, setSelectedDate, isMobile, sport,setWeekNumber,weekNumber} = props;
  const [paramsDate, setParamsDate] = useState(queryParams.search.slice(6))
  const navigate = useNavigate();

  const handleDateSelect = useCallback((e) => {
    // console.log('e.target.value =', e.target.value, selectedDate)
    setSelectedDate(e.target.value)
    navigate(`/${sport}/matches?week=${moment(e.target.value).format('YYYY-MM-DD')}`)
  }, [navigate])

  const handleClickOnToday = () => {

    let dropdownCalendar = document.getElementById('calendar');
    if (dropdownCalendar) {
      dropdownCalendar.addEventListener("focus", function (evt) {
        this.showPicker();
      });
      dropdownCalendar.focus();
    }
  }

  useEffect(() => {
    setParamsDate(queryParams?.search?.slice(6))
  }, [data, queryParams?.search]);

  return (
      <div
          className={
            moment(data?.week_start_date).format("YYYY-MM-DD") ===
            moment(paramsDate || Date.now()).format("YYYY-MM-DD")
                ?
                `col-2 calendar-item ${isMobile ? 'border-bottom-5 slider-mobile-news-menu' : 'bg-background'}`
                :
                "col-2 calendar-item"}
          style={{marginLeft: "auto", marginRight: "auto", width: 'max-content', textAlign: '-webkit-center'}}
      >
        {data && (
            <Link
                onClick={
(                    data?.week === weekNumber ||
                    moment(data?.week_start_date).format('YYYY-MM-DD') === moment(Date.now()).format('YYYY-MM-DD')) &&
                    handleClickOnToday}
                to={
                    moment(data?.week_start_date).format('YYYY-MM-DD') !== moment(Date.now()).format('YYYY-MM-DD') &&
                    `/${sport}/matches?week=${data?.week}`}
                className={`row text-decoration-none ${isMobile ? 'text-white' : 'text-black'}`}
                style={{width: 'max-content'}}
            >
              <div
                  className={
                    "text-center calendar-item-day text-uppercase"
                  }
              >
                {
                  (data?.week === weekNumber
                      || moment(data?.week_start_date).format('YYYY-MM-DD') === moment(Date.now()).format('YYYY-MM-DD')) ?
                      (<div className={`text-end sfProDisplayFontBold font-16`}> {data?.week_name}
                            <input style={{
                              pointerEvents: 'none',
                              width: isMobile ? '8px' : '14px',
                              border: '0px',
                              background: 'transparent',
                              color: isMobile ? '#fff' : 'transparent'
                            }}
                                   id={'calendar'}
                                   className={'icon-change-date'}
                                   onChange={(e) => {
                                     handleDateSelect(e)
                                   }}
                                   type={'date'}/>
                          </div>
                      )
                      : <div className={isMobile ? 'font-12' : 'font-16'}>{data?.week_name}</div>
                }
              </div>
            </Link>
        )}{" "}
        {data && (
            <Link
                onClick={                    (data?.week === weekNumber ||
                    moment(data?.week_start_date).format('YYYY-MM-DD') === moment(Date.now()).format('YYYY-MM-DD')) &&
                    handleClickOnToday}
                to={`/${sport}/matches?week=${data?.week}`}
                className={`row text-decoration-none ${isMobile ? 'text-white' : 'text-black'}`}
            >
              <div
                  className={
                    `text-center ${isMobile ? 'font-10' : 'font-16'} font-weight-500`
                  }
              >
                {
                  moment(data?.week_start_date).format('YYYY-MM-DD') === moment(Date.now()).format('YYYY-MM-DD') ?
                      isMobile ? <></> : <>
                        {moment(data?.week_start_date).format("MMM")}
                        &nbsp;
                        {moment(data?.week_start_date).date()}
                        -
                        {moment(data?.week_end_date).date()}
                      </>
                      : <>
                        {moment(data?.week_start_date).format("MMM")}
                        &nbsp;

                        {moment(data?.week_start_date).date()}
                        -
                        {moment(data?.week_end_date).date()}
                      </>
                }
              </div>
            </Link>
        )}
      </div>
  );
};

export default WeekCalendarContainerItem;
